<script setup lang="ts">
    import { ref } from 'vue';
    const props = defineProps(['question', 'no']);
    const emit = defineEmits(['nextQuestion'])

    const selectedAnswer = ref('');
    const isFeedbackShown = ref(false);
    const feedbackText = ref('');
    function showFeedback() {
        if (selectedAnswer.value === '') {
            alert('Lütfen bir cevap seçin.');
            return;
        }

        feedbackText.value = props.question.answers[selectedAnswer.value].feedbackText;
        isFeedbackShown.value = true;
    }

    function emitNextQuestion() {
        emit('nextQuestion');
    }
</script>

<template>
    <div>
        <div v-if="isFeedbackShown === false">
            <h3 v-html="props.question.title"></h3>
            <div v-html="props.question.description"></div>

            <div class="mt-4" v-html="props.question.questionText"></div>
            <div v-for="(answer, index) in props.question.answers" :key="index"
                 class="flex items-center mb-3  rounded-xl px-4 py-3 border-gray-500 border-2 cursor-pointer hover:bg-primary-50 hover:border-primary-default"
                 :class="{'mt-4': index == 0, 'bg-primary-50 border-primary-default': selectedAnswer === index}" @click="selectedAnswer = index">
                <span>{{ answer.text }}</span>
            </div>

            <button class="btn btn-primary mt-8" @click="showFeedback">Devam Et</button>
        </div>
        <div v-else>
            <img src="https://tll.mit.edu/wp-content/uploads/2020/09/absolutvision-82TpEld0_e4-unsplash-scaled-e1600182388853-2048x1024.jpg"
                 class="w-64 mb-4"  />
            <div class="font-bold" v-html="feedbackText"></div>
            <div v-if="props.question.feedbackExtraText" class="font-bold" v-html="props.question.feedbackExtraText"></div>

            <button class="btn btn-primar mt-8" @click="emitNextQuestion">Devam Et</button>
        </div>
    </div>
</template>

<style scoped>

</style>
